import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumb, Button, DatePicker, Divider, Input, Popover, Select } from 'antd'
import { FilterOutlined } from '@ant-design/icons'
import styles from './styles.css'

const Spacer = () => <div style={{ width: 12 }} />

const Box = props => <div className={styles.box}>{props.children}</div>

const Label = props => <div className={styles.label}>{props.text}</div>

const Header = props => {

  const {
    search,
    filters,
    isFiltered,
    onChangeSearch,
    onSearch,
    onChangeFilter,
  } = props

  const popover = (
    <div className={styles.filters}>
      <Box>
        <Label text='Date' />
        <DatePicker.RangePicker
          value={filters.date_range}
          onChange={value => onChangeFilter('date_range', value || [])}
          format='DD/MM/YYYY'
          placeholder={['Start Date', 'End Date']}
          style={{ width: '100%' }}
        />
      </Box>
    </div>
  )

  return (
    
    <React.Fragment>

      <Breadcrumb separator='»'>

        <Breadcrumb.Item>
          Home
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          My Orders
        </Breadcrumb.Item>

      </Breadcrumb>

      <Divider />

      <h1>My Orders</h1>

      <div className={styles.controls}>

        <div className={styles.left}>

          <Input.Search
            value={search}
            onChange={e => onChangeSearch(e.target.value)}
            onSearch={onSearch}
            placeholder='Search...'
            style={{ width: 250 }}
          />

          <Spacer />

          <Popover
            trigger={['click']}
            placement='bottom'
            content={popover}
          >
            <Button type={isFiltered && 'primary'} icon={<FilterOutlined />}>Filter</Button>
          </Popover>

        </div>

        <div className={styles.right}>
          {/* Subcontractors cannot create new orders */}
        </div>

      </div>

    </React.Fragment>

  )

}

Box.propTypes = {
  children: PropTypes.node.isRequired,
}

Label.propTypes = {
  text: PropTypes.string.isRequired,
}

Header.propTypes = {
  search: PropTypes.string.isRequired,
  filters: PropTypes.object.isRequired,
  isFiltered: PropTypes.bool.isRequired,
  onChangeSearch: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
}

export default Header
